import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDislikeChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2130_20236)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.0001 8.66667V5.33333C15.999 4.4496 15.6475 3.60237 15.0226 2.97748C14.3977 2.35259 13.5505 2.00106 12.6668 2H12.0001V12H12.6668C13.5505 11.9989 14.3977 11.6474 15.0226 11.0225C15.6475 10.3976 15.999 9.5504 16.0001 8.66667ZM0.502839 4.86667L0.0328388 8.2C-0.0339661 8.67248 0.00145149 9.15381 0.136698 9.61142C0.271945 10.069 0.503867 10.4923 0.816786 10.8525C1.12971 11.2128 1.51633 11.5017 1.95051 11.6996C2.3847 11.8976 2.85632 12 3.33351 12H5.99284L5.76884 13.364C5.69048 13.8428 5.78661 14.3338 6.03973 14.7478C6.29286 15.1617 6.68616 15.471 7.14809 15.6194C7.61001 15.7678 8.10986 15.7454 8.5567 15.5564C9.00353 15.3673 9.36766 15.0242 9.58284 14.5893L10.6668 12.3893V2H3.80017C2.99844 2.00408 2.22476 2.29562 1.61971 2.82164C1.01466 3.34767 0.618367 4.07329 0.502839 4.86667Z",
			fill: "#333333"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2130_20236",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgDislikeChecked;
